<template>
    <div class="main-cn">
        <div class="main-hd">
            <h4>审批列表</h4>
        </div>

        <div class="main-bd mg20 pro-visible">
            <el-row class="searchSection">
                <el-tabs v-model="activeTab" @tab-click="handleClick">
                    <el-tab-pane label="我发起的审批" v-if="Acs('/approve/index')" name="send"></el-tab-pane>
                    <el-tab-pane label="待我审批" v-if="Acs('/approve/todo')" name="receive"></el-tab-pane>
                    <el-tab-pane label="抄送我的" v-if="Acs('/approve/copy-to-me')" name="copy"></el-tab-pane>
                </el-tabs>
            </el-row>
            <div>
                <el-form :inline="true" ref="form" :model="form" :key="activeTab">
                    <el-form-item label="订单类型">
                        <el-select size="small" v-model="form.order_type"  placeholder="请选择">
                            <el-option v-for="(item, key) in order_type_select" :key="key" :label="item.label"
                                       :value="item.value">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="审批类型">
                        <el-select size="small" v-model="form.type"  placeholder="请选择">
                            <el-option v-for="(item, key) in send_check_type" :key="key" :label="item.label"
                                       :value="item.value">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="审批状态">
                        <el-select size="small" v-model="form.status"
                                   placeholder="请选择">
                            <el-option v-for="(item, key) in check_status" :key="key" :label="item.label"
                                       :value="item.value">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="客户名称">
                        <CustomerSelect ref="customer" v-model="form.customer_name"
                                        @change="CustomerHandleChange"></CustomerSelect>
                    </el-form-item>
                    <el-form-item label="订单ID">
                       <el-input size="small" placeholder="请输入订单号" v-model="form.order_id"></el-input>
                    </el-form-item>
                    <el-form-item label="所属部门" v-if="activeTab=='copy' || activeTab=='receive'">
                        <UserCascader ref="branch" v-model="form.branch_id" :isBusiness="true" @change="changeBranch"></UserCascader>
                    </el-form-item>
                    <el-form-item label="申请人" v-if="activeTab=='copy' || activeTab=='receive'">
                        <user-select ref="user_apply" @change="proposer"></user-select>
                    </el-form-item>
                    <el-form-item label="审核人" v-if="activeTab=='copy'">
                        <user-select ref="user_checker" @change="auditor"></user-select>
                    </el-form-item>
                    <el-form-item v-if="form.status === 1 || form.status === 0" label="审核时间">
                        <el-date-picker
                                size="small"
                                v-model="approve_times"
                                type="daterange"
                                range-separator="至"
                                start-placeholder="开始日期"
                                end-placeholder="结束日期"
                                format="yyyy-MM-dd"
                                value-format="timestamp"
                                align="right">
                        </el-date-picker>
                    </el-form-item>

                    <el-form-item>
                        <el-button type="primary" size="small" icon="el-icon-search" @click="submitSearch">搜索
                        </el-button>
                        <el-button @click="resetForm()" size="small">重置</el-button>
                        <ExportFields 
                            v-if="activeTab=='receive'"
                            buttonName="导出订单"
                            url="/api/approve/export-order"
                            :params="form"
                            filename='销售数据表' 
                            title='导出订单数据'
                            :export_field_list="export_field_list"
                            cache_field="export_order_field"
                            :path="this.$route.path"
                            :tab="activeTab"
                        ></ExportFields>
                    </el-form-item>
                </el-form>
            </div>
            <el-table :data="list" :key="activeTab" style="width: 100%" v-loading="loading">
                <el-table-column label="审批内容" prop="desc" width="320">
                    <template slot-scope="scope">
                        <span v-html="scope.row.desc"></span>
                    </template>
                </el-table-column>
                <el-table-column label="订单类型" prop="order_type_meno">
                </el-table-column>
                <el-table-column label="审批类型" prop="type_memo">
                </el-table-column>
                <el-table-column label="申请人" prop="proposer">
                </el-table-column>
                <el-table-column label="申请时间" prop="created_at">
                </el-table-column>
                <el-table-column v-if="activeTab == 'copy'" label="审核人" prop="flow_node_executor_id">
                    <template slot-scope="scope">
                        <span>{{scope.row.executor_memo}}-{{scope.row.created_at}}</span>
                    </template>
                </el-table-column>
                <el-table-column label="审核状态" prop="status">
                    <template slot-scope="scope">
                        <!--状态展示-->
                        <el-popover
                                placement="left-start"
                                width="500"
                                trigger="hover"
                        >
                                <el-steps v-if="popover_data" :space="200" :active="popover_data.step" :key="popover_data.id" finish-status="success">

                                    <slot v-for="value in popover_data.checker">
                                        <el-step :title="value.name">
                                            <template slot="description" v-if="value.status == 1">
                                                <div>{{value['updated_at']}}</div>
                                                <div v-if="value['log']">审核意见：{{value['log']['memo']}}</div>
                                            </template>
                                            <template  v-else-if="value.status == 0">
                                                <span slot="icon" class="el-icon-close" style="color: red"></span>
                                                <span slot="title" style="color: red">{{value.name}}</span>
                                                <span slot="description" style="color: red">
                                            <div>审核不通过</div>
                                            <div>{{value['updated_at']}}</div>
                                            <div>审核意见：{{value['log']['memo']}}</div>
                                            </span>
                                            </template>
                                            <template slot="description" v-else-if="value.status == 2">
                                                待审核
                                            </template>
                                            <template slot="description" v-else-if="value.status == 3">
                                                待审核
                                            </template>
                                        </el-step>
                                        <el-step v-if="value.is_last" title="完成"></el-step>
                                    </slot>
                                </el-steps>
                            <div slot="reference">
                                <span v-if="activeTab=='receive'" @mouseenter="popover_data=scope.row" >
                                    <el-button type="text" style="color: #67C23A" v-if="scope.row.status == 1 " >审核通过</el-button>
                                    <el-button type="text" style="color: #F56C6C" v-else-if="scope.row.status == 0 " >不通过</el-button>
                                    <el-button type="text" style="color: #F56C6C" v-else-if="scope.row.status == 3 " >已撤回</el-button>
                                    <el-button type="text" style="color: #E6A23C" v-else="scope.row.status == 2 "  >待审核</el-button>
                                </span>
                                <span v-else @mouseenter="popover_data=scope.row" >
                                    <el-button type="text" style="color: #67C23A" v-if="scope.row.ultimate_status == 1 " >审核通过</el-button>
                                    <el-button type="text" style="color: #F56C6C" v-else-if="scope.row.ultimate_status == 0 " >不通过</el-button>
                                    <el-button type="text" style="color: #F56C6C" v-else-if="scope.row.ultimate_status == 3 " >已撤回</el-button>
                                    <el-button type="text" style="color: #E6A23C" v-else="scope.row.ultimate_status == 2 " >待审核</el-button>
                                </span>
                            </div>
                        </el-popover>
                    </template>
                </el-table-column>
                <el-table-column label="审核时间" prop="updated_at">
                    <template slot-scope="scope">
                        <span v-if="scope.row.status != 2">{{scope.row.updated_at}}</span>
                        <span v-else>--</span>
                    </template>
                </el-table-column>
                <el-table-column label="操作">
                    <template slot-scope="scope">
                        <el-button v-if="activeTab == 'send'"  type="primary" size="small"
                                   @click="showDetail(scope.row)">审批详情
                        </el-button>
                        <el-button v-else-if="activeTab == 'copy'" type="primary" @click="showDetail(scope.row)">
                            查看
                        </el-button>
                        <span v-else>
                             <el-button v-if="scope.row['is_checked']" type="info" size="small"
                                        @click="showDetail(scope.row)">已审核
                            </el-button>
                            <el-button v-else :type="scope.row.button_status ? scope.row.button_status : 'primary'" size="small"
                                       @click="showDetail(scope.row, true)">审核
                            </el-button>
                        </span>
                    </template>
                </el-table-column>
            </el-table>
            <el-row v-if="linkPage">
                <pagination :linkPage="linkPage"></pagination>
            </el-row>
        </div>
    </div>
</template>
<style>
    .scrollbar .el-table__body-wrapper::-webkit-scrollbar {
        width: 1px; /*一定要给高度，不然下面的样式无效，很蛋疼*/
    }

    .scrollbar .el-table__body-wrapper::-webkit-scrollbar-thumb {
        background: #99a9bf;
        border-radius: 5px;
    }
</style>
<script>
    import Pagination from "~/widgets/Pagination.vue";
    import ApproveService from "~/services/approve";
    import Config from "~/config/params";
    import UserSelect from "~/widgets/UserSelect.vue";
    import OrderService from "~/services/order";
    import CustomerSelect from "~/widgets/CustomerSelect.vue";
    import ExportFields from "~/widgets/ExportFields.vue";
    import UserCascader from "~/widgets/UserCascader.vue";

    export default {
        components: {
            Pagination,
            Config,
            UserSelect,
            CustomerSelect,
            ExportFields,
            UserCascader
        },
        data() {
            return {
                loading: false,
                popover_data: null,
                activeTab: 'receive',
                activeNames: ['1'],
                performance_amount: 0,
                form:{
                    status:'',
                    type:'',
                    order_id:'',
                    apply_user:'',
                    flow_node_executor_name:'',
                    send_user_name:'',
                    customer_name:'',
                    start_at: '',
                    end_at: '',
                    order_type:'',
                    branch_id: '',
                },
                order_type: [
                    {
                        value: Config.TYPE_TRY_OUT,
                        label: '试用'
                    }, {
                        value: Config.TYPE_FORMAL,
                        label: '新增'
                    }, {
                        value: Config.TYPE_RENEW,
                        label: '续费'
                    }
                ],
                check_type: [
                    {
                        value: Config.TYPE_TRY_OUT,
                        label: '试用'
                    }, {
                        value: Config.TYPE_FORMAL,
                        label: '新增'
                    }, {
                        value: Config.TYPE_RENEW,
                        label: '续费'
                    }
                ],
                order_type_select : [
                    {
                        value: 0,
                        label: '全部'
                    }, {
                        value:1,
                        label:"试用",
                    }, {
                        value:2,
                        label:"正式(新单)",
                    },{
                        value:3,
                        label:"正式(续费)",
                    }
                ],
                send_check_type: [
                    {
                        value: 0,
                        label: '全部'
                    }, {
                        value: 1,
                        label: '新增订单'
                    }, {
                        value: 2,
                        label: '关闭订单'
                    }, {
                        value: 3,
                        label: '修订订单'
                    }, {
                        value: 4,
                        label: '补充订单'
                    }
                ],
                check_status: [
                    {
                        value: 3,
                        label: '全部'
                    },
                    {
                        value: 2,
                        label: '待审核'
                    }, {
                        value: 1,
                        label: '通过'
                    }, {
                        value: 0,
                        label: '未通过'
                    }
                ],

                types: {},
                list: [],
                // 分页信息
                linkPage: null,
                // 按审批时间筛选组件绑定属性
                approve_times: [],
                export_field_list: [],
            };
        },
        // 监听路由参数更新执行分页请求
        beforeRouteUpdate: function (to, from, next) {
            let params = this.form;
            params['page'] = to.query["page"];
            params['perPage'] = to.query["perPage"];
            this.initListData(params);
        },
        created: function () {
            OrderService.getOrderExportFields().forEach(item => {
                if(this.Acs('/export/order-list-' + item.field)){
                    this.export_field_list.push(item);
                }
            });
            if (this.Acs('/approve/todo')) {
                this.activeTab = 'receive'
            } else {
                this.activeTab = 'send'
            }
            this.form.status = 2;
            if(this.activeTab=='copy'){
                this.form.status = 3;
            }
            this.form.type = 0;
            this.initListData({status: this.form.status});
        },

        methods: {
            //客户名称远程搜索组件赋值
            CustomerHandleChange(object) {
                this.form.customer_name = object.value;
            },

            submitSearch(){
                if (this.approve_times && this.approve_times.length > 0) {
                    if (this.approve_times[0]) {
                        this.form.start_at = this.approve_times[0];
                    }

                    if (this.approve_times[1]) {
                        this.form.end_at = this.approve_times[1];
                    }
                } else {
                    this.form.start_at = '';
                    this.form.end_at = '';
                }

                this.initListData(this.form);
            },
            resetForm(){
                this.$refs['customer'].reset();
                if(this.$refs['user_apply']){
                    this.$refs['user_apply'].reset();
                }
                if(this.$refs['user_checker']){
                    this.$refs['user_checker'].reset();
                }
                this.form = Object.assign(this.form,{
                    status:'',
                    type:'',
                    order_id:'',
                    apply_user:'',
                    flow_node_executor_name:'',
                    send_user_name:'',
                    customer_name:'',
                    start_at: '',
                    end_at: ''
                })
                this.approve_times = [];
            },
            //获取我发起的审批列表
            sendApprove(params = {}) {
                this.loading = true;
                ApproveService.sendApprove(params).then(res => {
                    console.log(res);
                    this.loading = false;
                    this.list = res.data;
                    this.popover_data = this.list[0];
                    console.log(this.popover_data)
                    if (res._meta) {
                        this.linkPage = res._meta;
                    }
                });
            },
            todo(params) {
                this.loading = true;
                ApproveService.todo(params).then(res => {
                    this.loading = false;
                    this.list = res.data;
                    if (res._meta) {
                        this.linkPage = res._meta;
                    }
                });
            },

            copyToMe(params) {
                this.loading = true;
                ApproveService.copyToMe(params).then(res => {
                    this.loading = false;
                    this.list = res.data;
                    if (res._meta) {
                        this.linkPage = res._meta;
                    }
                });
            },

            initListData(params = {}) {
                if (this.activeTab == 'send') this.sendApprove(params);
                if (this.activeTab == 'receive') this.todo(params);
                if (this.activeTab == 'copy') this.copyToMe(params);

            },
            handleClick(tab, event) {
                this.resetForm();
                this.activeTab = tab.name;
                this.form.status = 2;
                if(this.activeTab=='copy'){
                    this.form.status = 3;
                }
                this.initListData({status: this.form.status});
                this.form.type = 0;
            },
            proposer($event) {
                this.form.send_user_name = $event.value;
            },
            auditor($event) {
                this.form.flow_node_executor_name = $event.value;
            },
            /**
             * @todo 跳转到订单详情页
             * @param event
             */
            showDetail(data, status = 0) {
                const project = this.list.find(item => item.id == data.id);
                if (project) {
                    this.$set(project, 'button_status', 'info');
                }

                let routeData = this.$router.resolve({
                    path: "/order/view",
                    query: { id: data.order_id, flow_type: data.flow_type, type: data.type, revise_id: data.order_edit_id },
                });
                window.open(routeData.href, '_blank');
            },

            changeBranch(value) {
                if (value.length > 0) {
                    // 取得最后一级部门作为所属部门
                    this.form.branch_id = value[value.length - 1];
                } else {
                    this.form.branch_id = "";
                }
            },
        }
    };
</script>


// WEBPACK FOOTER //
// src/views/order/business.vue